export default "__VITE_ASSET__413aabf5__"